var map = {
	"./facebook.png": 97276,
	"./instagram.png": 51646,
	"./line.png": 26493,
	"./linkedin.png": 86822,
	"./pinterest.png": 15165,
	"./skype.png": 68385,
	"./telegram.png": 17280,
	"./twitter.png": 4803,
	"./wechat.png": 98224,
	"./whatsapp.png": 36869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96512;